import { render, staticRenderFns } from "./ProjectStatistics.vue?vue&type=template&id=282b7c57&scoped=true&"
import script from "./ProjectStatistics.vue?vue&type=script&lang=js&"
export * from "./ProjectStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatistics.vue?vue&type=style&index=0&id=282b7c57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b7c57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VSelect,VTab,VTabItem,VTabs,VTabsItems})
